import client from "../Client/HttpClient";
import { IUsersModel } from "@/interfaces/modules";
const ApiPath = "SystemUsers";

export default {
    GetSystemUsers:() : Promise <IUsersModel[]> => client.get(`${ApiPath}`),
    GetSystemUsersbyId: (Id: any): Promise <IUsersModel> => client.get(`${ApiPath}/${Id}`), 
    PostSystemUsers: (data: any): Promise<any> => client.post(`${ApiPath}`, data)
  };